import { formatDate } from '@ui/src';
import { TransactionMonitoringRule } from '../../types';

const formatTransationMonitoringRuleList = (
  list: TransactionMonitoringRule[],
): TransactionMonitoringRule[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let action;

    if (result?.action === 'PASS') {
      action = 'Pass';
    } else if (result?.action === 'AML_REVIEW') {
      action = 'AML Review';
    } else if (result?.action === 'OPS_REVIEW') {
      action = 'OPS Review';
    }

    const render: Record<string, React.JSX.Element> = {
      createdAt: <div>{formatDate(item.createdAt)}</div>,
      active: <div>{result.active ? 'Active' : 'Inactive'}</div>,
      name: <div>{result.name}</div>,
      action: <div>{action}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatTransationMonitoringRuleList;
